import React from 'react';
import { Form } from 'semantic-ui-react';

const TenoviGlucometer = ({
  tenoviDeviceTypes,
  setTenoviDeviceTypes,
}) => {
  return (
    <>
      {' '}
      <Form.Group inline>
        <label style={{ width: '150px' }}>Blood Glucose Meter</label>
        <Form.Radio
          label="Request"
          value="request"
          checked={
            tenoviDeviceTypes.TENOVI_GLUCOMETER.state === 'request'
          }
          onChange={(e, { value }) =>
            setTenoviDeviceTypes({
              ...tenoviDeviceTypes,
              TENOVI_GLUCOMETER: {
                ...tenoviDeviceTypes.TENOVI_GLUCOMETER,
                state: value,
              },
            })
          }
        />
        <Form.Radio
          label="Connect"
          value="connect"
          checked={
            tenoviDeviceTypes.TENOVI_GLUCOMETER.state === 'connect'
          }
          onChange={(e, { value }) =>
            setTenoviDeviceTypes({
              ...tenoviDeviceTypes,
              TENOVI_GLUCOMETER: {
                ...tenoviDeviceTypes.TENOVI_GLUCOMETER,
                state: value,
              },
            })
          }
        />
        <Form.Radio
          label="Not needed"
          value="notNeeded"
          checked={
            tenoviDeviceTypes.TENOVI_GLUCOMETER.state === 'notNeeded'
          }
          onChange={(e, { value }) =>
            setTenoviDeviceTypes({
              ...tenoviDeviceTypes,
              TENOVI_GLUCOMETER: {
                ...tenoviDeviceTypes.TENOVI_GLUCOMETER,
                state: value,
              },
            })
          }
        />
      </Form.Group>
    </>
  );
};

export default TenoviGlucometer;
